import { FC } from 'react';

import { useCardOfferDataContext } from 'shared/context/CardContext';
import { useCAForCard } from 'shared/hooks/useCAForCard';

import { CardAddressBlock } from './CardAddressBlock';

export const CardAddressBlockContainer: FC = () => {
  const {
    geo: { address },
  } = useCardOfferDataContext();

  const caForCard = useCAForCard();

  return (
    <CardAddressBlock
      address={address}
      track={(): void => caForCard({ action: 'click_sopr', category: 'Listing', label: 'to_listing_address' })}
    />
  );
};
